import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';
import TextPercent from 'components/text/TextPercent';
import TextNumber from 'components/text/TextNumber';
import TransactionKey from 'calculator/components/TransactionKey';
import TextCalculatedFor from 'calculator/components/TextCalculatedFor';


const ReturnSummaryResultList = ({ data }) => {    
    if (!data){
      return (
        <div/>
      );
    }
    
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="8" className="text-left">
              <span className="calc-setting-table-header">Útreiknuð skil miðað við stöðu máls og fyrri skil ef til staðar.</span>
            </th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Nú skilað</th>
            <th className="text-right">Inneign</th>
            <th className="text-right">Áður skilað</th>
            <th className="text-right">Afsláttur</th>
            <th className="text-right">Eftirst.</th>
            <th className="text-right">Samtals</th>
            <th className="text-right">Jöfn.</th>
          </tr>
          </thead>
          <tbody>
          {data.returnSummaries.map((item,i) => {
            if (item.notIncludedInTotal) {
              return null;
            }
            return(
                <tr key={i + "before"}>
                  <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                  <td className="text-right"><TextAmount value={item.returnNow}/></td>
                  <td className="text-right"><TextAmount value={item.credit}/></td>
                  <td className="text-right"><TextAmount value={item.previouslyReturned}/></td>
                  <td className="text-right"><TextAmount value={item.discount}/></td>
                  <td className="text-right"><TextAmount value={item.remainingAmount}/></td>
                  <td className="text-right"><TextAmount value={item.totalAmount}/></td>
                  <td className="text-right"><TextAmount value={item.evenOutAmount}/></td>
                </tr>)
          })}
          <tr className="highlight-principal-future">
            <td className="text-left">Samtals:</td>
            <td className="text-right"><TextAmount value={data.totalReturnNow}/></td>
            <td className="text-right"><TextAmount value={data.totalCredit}/></td>
            <td className="text-right"><TextAmount value={data.totalPreviouslyReturned}/></td>
            <td className="text-right"><TextAmount value={data.totalDiscount}/></td>
            <td className="text-right">&nbsp;</td>
            <td className="text-right">&nbsp;</td>
            <td className="text-right">&nbsp;</td>
            <td className="text-right">&nbsp;</td>
          </tr>
          {data.returnSummaries.map((item,i) => {
            if (!item.notIncludedInTotal) {
              return null;
            }
            return(
              <tr key={i + "notInTotal"}>
                <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><TextAmount value={item.returnNow}/></td>
                <td className="text-right"><TextAmount value={item.credit}/></td>
                <td className="text-right"><TextAmount value={item.previouslyReturned}/></td>
                <td className="text-right">&nbsp;</td>
                <td className="text-right"><TextAmount value={item.remainingAmount}/></td>
                <td className="text-right"><TextAmount value={item.totalAmount}/></td>
                <td className="text-right"><TextAmount value={item.evenOutAmount}/></td>
              </tr>)
          })}


          </tbody>
        </table>
      </div>
    );  
}

ReturnSummaryResultList.propTypes = {
  data: PropTypes.any,
};



export default ReturnSummaryResultList;
